var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuy = function SvgBuy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59892 4.74667L13.7139 7.3375C14.3315 7.54036 14.871 7.92985 15.2579 8.45226C15.6447 8.97467 15.86 9.60425 15.8739 10.2542V19.0125C15.8999 19.289 15.8581 19.5677 15.7523 19.8244C15.6464 20.0812 15.4795 20.3083 15.2662 20.4861C15.0529 20.6639 14.7995 20.7871 14.5278 20.845C14.2562 20.9028 13.9745 20.8937 13.7072 20.8183L6.16725 18.7683C5.54954 18.5762 5.00793 18.1945 4.61909 17.6775C4.23024 17.1605 4.01386 16.5342 4.00059 15.8875V6.34417C3.9869 5.73885 4.21315 5.15268 4.62997 4.71353C5.0468 4.27438 5.62038 4.01788 6.22559 4H17.7489C18.412 4 19.0479 4.26339 19.5167 4.73223C19.9855 5.20107 20.2489 5.83696 20.2489 6.5V13.9608C20.246 14.2979 20.1765 14.631 20.0446 14.9412C19.9127 15.2513 19.7209 15.5324 19.4801 15.7683C19.2393 16.0042 18.9544 16.1902 18.6415 16.3158C18.3288 16.4413 17.9943 16.504 17.6572 16.5H15.8739",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4363 14C12.2637 14 12.1238 13.8601 12.1238 13.6875C12.1238 13.5149 12.2637 13.375 12.4363 13.375",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4363 14C12.6089 14 12.7488 13.8601 12.7488 13.6875C12.7488 13.5149 12.6089 13.375 12.4363 13.375",
    stroke: "#000033",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2488 10.25H15.8738",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBuy;